import { render, staticRenderFns } from "./MyTextOneMobile.vue?vue&type=template&id=563ddd52&scoped=true"
import script from "./MyTextOneMobile.vue?vue&type=script&lang=js"
export * from "./MyTextOneMobile.vue?vue&type=script&lang=js"
import style0 from "./MyTextOneMobile.vue?vue&type=style&index=0&id=563ddd52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ddd52",
  null
  
)

export default component.exports